import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://www.agrilivemarket.com';
const DEFAULT_TITLE = 'AgriLive — Verified Digital Agriculture Marketplace';
const DEFAULT_DESCRIPTION = 'Connecting smallholder farmers directly to fair, verified markets — seed to table.';
const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;

const Seo = ({ title, description = DEFAULT_DESCRIPTION, path = '/', image = DEFAULT_IMAGE }) => {
  const fullTitle = title ? `${title} | AgriLive` : DEFAULT_TITLE;
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default Seo;
